import * as p from '@clack/prompts'
import type { PackageManager } from '@cli-types/core-engine/utils.js'
import { DRIZZLE_KIT_POSTGRES_DRIVER_DEP, POSTGRES_RUNTIME_DEP } from '@cli-constants/deps.js'
import { hasDrizzleKitPostgresDriverDependency } from '@next-adapter/init/scaffolders/dependencies/has-drizzle-kit-postgres-driver-dependency.js'
import { hasPostgresRuntimeDependency } from '@next-adapter/init/scaffolders/dependencies/has-postgres-runtime-dependency.js'
import { installDependency } from './install-dependency.js'

export async function ensureDatabasePushDependencies(
  cwd: string,
  pm: PackageManager
): Promise<boolean> {
  const missing: Array<{ name: string; dev: boolean }> = []

  if (!hasPostgresRuntimeDependency(cwd)) {
    missing.push({ name: POSTGRES_RUNTIME_DEP, dev: false })
  }

  if (!hasDrizzleKitPostgresDriverDependency(cwd)) {
    missing.push({ name: DRIZZLE_KIT_POSTGRES_DRIVER_DEP, dev: true })
  }

  if (missing.length === 0) {
    return true
  }

  p.log.info(
    `Installing database push dependencies (${missing.map((dependency) => dependency.name).join(', ')})...`
  )

  for (const dependency of missing) {
    const installed = await installDependency(cwd, pm, dependency.name, dependency.dev)
    if (!installed) {
      p.log.warn(`Failed to install ${dependency.name}`)
      return false
    }
  }

  const ready = hasPostgresRuntimeDependency(cwd) && hasDrizzleKitPostgresDriverDependency(cwd)

  if (ready) {
    p.log.success('Database push dependencies installed')
  } else {
    const unresolved = [
      !hasPostgresRuntimeDependency(cwd) ? POSTGRES_RUNTIME_DEP : null,
      !hasDrizzleKitPostgresDriverDependency(cwd) ? DRIZZLE_KIT_POSTGRES_DRIVER_DEP : null
    ].filter((dependency): dependency is string => Boolean(dependency))
    p.log.warn(`Installed dependencies but could not resolve ${unresolved.join(', ')}`)
  }

  return ready
}
